/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/newConnection/NewConnectionPanel" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { NewConnection } from "Wit/Settings/BoardsExternalIntegration/components/common";
import { BasePanel } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanel";
import { INewConnectionPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/newConnection/NewConnectionPanel.Props";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";

export interface INewConnectionPanelState {
    errorMessage?: string;
    loadingSpinnerMessage?: string;
}

export class NewConnectionPanel extends VssComponent<INewConnectionPanelProps, INewConnectionPanelState, IVssComponentContext> {
    constructor(props: INewConnectionPanelProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            errorMessage: undefined,
            loadingSpinnerMessage: undefined
        };
    }

    public render() {
        return (
            <BasePanel
                onDismiss={this.props.onDismiss}
                className="new-connection-panel"
                title={Resources.NewConnection_title}
                onRenderHeaderContent={this._renderHeader}
                errorMessage={this.state.errorMessage}
                onDismissErrorMessage={this._onDismissErrorMessage}
                loadingSpinnerMessage={this.state.loadingSpinnerMessage}
            >
                <NewConnection
                    onConnectButtonClick={this._onConnectGitHubAccountButtonClick}
                    showPanel={this.props.showPanel}
                    onOAuthError={this._onOAuthError}
                    disableOAuth={this.props.disableOAuth}
                />
            </BasePanel>
        );
    }

    private _onConnectGitHubAccountButtonClick = () => {
        this.setState({ loadingSpinnerMessage: Resources.SpinnerConnectingAccountText });
    };

    private _onOAuthError = (error: Error) => {
        this.setState({ loadingSpinnerMessage: undefined });
    };

    private _onDismissErrorMessage = () => {
        this.setState({ errorMessage: undefined });
    };

    private _renderHeader = () => {
        return <div>{Resources.NewConnection_subheader}</div>;
    };
}
